<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-form ref="form" :lazy-validation="false">
        <v-card-title>
          <span class="headline">Update Agent</span>
        </v-card-title>
        <v-alert v-show="!!error" text prominent type="error" icon="mdi-alert-circle">
          <span v-html="error" />
        </v-alert>
        <v-alert
          v-show="!!success"
          text
          prominent
          type="success"
          icon="mdi-cloud-check"
        >Succesfully Updated as {{item.status}}</v-alert>
        <v-card-text>
          <v-container v-if="!success">Are you sure to update this agent as {{item.status}}?</v-container>
          <v-container class="text-center" v-if="loading">
            <v-progress-circular :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-show="!success" depressed color="primary" @click="updateItem()">Update</v-btn>
          <v-btn color="grey darken-1" text @click="toggleDialog">{{success ? "Close" : "Cancel"}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  UPDATE_RADAR,
  TOGGLE_UPDATE_RADAR_DIALOG,
} from "../../store/modules/radar";

export default {
  computed: {
    ...mapState("radar", {
      item: (state) => state.updateRadar.item,
      dialog: (state) => state.updateRadar.dialog,
      loading: (state) => state.updateRadar.isLoading,
      success: (state) => state.updateRadar.success,
      error: (state) => state.updateRadar.error,
    }),
  },
  methods: {
    ...mapActions("radar", {
      updateRadar: UPDATE_RADAR,
      toggleDialog: TOGGLE_UPDATE_RADAR_DIALOG,
    }),
    updateItem() {
      this.updateRadar(this.item);
    },
  },
};
</script>